import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const login = createAsyncThunk(
  "login/loginUsers",
  async (payload, thunkAPI) => {
    try {
      
       // login
      const response = await api.post("signin", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
       
        console.log(43, action.payload)
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
